import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

let isLoggingOut = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: any) => {

      if (error.status === 401) {
        if (!isLoggingOut) {
          isLoggingOut = true;
          authService.logout();
          setTimeout(() => {
            isLoggingOut = false;
          }, 1000);
        }
      }

      if (error.status === 403) {
        console.warn('⚠ 403: User does not have permission.');
        console.error(error);
      }

      if (error.status === 500) {
        console.error(error);
      }

      if (error.status === 0) {
        console.error('Network error: Please check your internet connection or try again later.');
      }

      const errorMessage = error?.error?.message || error.statusText;
      console.log(errorMessage);

      return throwError(() => error);
    })
  );
}